import React from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import HorizontalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

// Pages
import NotFound from "../pages/Authentication/NotFound";

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected route={route}>
                <HorizontalLayout>{route.component}</HorizontalLayout>
              </AuthProtected>
            }
            key={idx}
            exact={true}
          />
        ))}

        {/* Yetkisiz erişim sayfası */}
        <Route path="/404" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  );
};

export default Index;
